<template>
  <v-container>
    <v-card>
      <v-container class="pb-0 mobile-container">
        <v-card-actions class="pb-0 pt-2">
          <span class="text-h5 pl-1">Importación de entidades emisoras</span>
          <v-spacer></v-spacer>
          <v-tooltip text="Cerrar" location="left">
            <template v-slot:activator="{ props }">
              <v-btn
                color="primary"
                v-bind="props"
                class="to-right"
                :icon="closeIcon"
                id="v-btn-close-importar-entidades-emisoras"
                @click="closeModal"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </v-card-actions>
        <v-card-text class="px-0">
          <v-row>
            <v-col cols="12" class="px-2">
              <v-file-input
                ref="file"
                v-model="file"
                :disabled="loading"
                :loading="loading"
                id="file-input-excel-emisores"
                type="file"
                dense
                variant="underlined"
                label="Excel"
                placeholder="Seleccionar el archivo Excel"
                accept=".xls,.xlsx,.csv"
                outlined
                @change="importExcel"
                @click:clear="clearExcelFile"
                prepend-icon="mdi-paperclip"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-3 pr-0">
          <v-btn
            color="success"
            variant="text"
            @click="openFormatoModal"
            id="v-btn-ver-formato-entidades-emisoras"
          >
            Ver formato
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="flat"
            type="submit"
            :disabled="!enableProcess || !file"
            :loading="loadingBtn"
            form="submit-form"
            @click="saveFileData"
            id="v-btn-importar-entidades-emisoras"
          >
            Importar
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-dialog
      v-if="openModalElegirEmisoresRepetidos"
      v-model="openModalElegirEmisoresRepetidos"
      :max-width="isMobile ? '95%' : '95%'"
      persistent
    >
      <v-card>
        <v-container>
          <v-card-actions class="pb-0 pt-2">
            <span class="text-h5">Entidades emisoras repetidas</span>
            <v-spacer></v-spacer>
            <v-tooltip text="Cerrar" location="left">
              <template v-slot:activator="{ props }">
                <v-btn
                  color="primary"
                  v-bind="props"
                  class="to-right"
                  :icon="closeIcon"
                  id="v-btn-close-modal-emisores-repetidos"
                  @click="cerrarModalRepetidos"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-card-actions>
          <v-card-text class="px-0">
            <v-data-table
              :headers="emisoresRepetidosHeaders"
              :hide-default-header="isMobile"
              :items="emisoresRepetidos"
              outlined
              :loading="dataTableIsLoading"
            >
              <template v-slot:[`item.selectEmisor`]="{ item }">
                <div v-if="item && item.emisoresCoincidentes.length > 0">
                  <v-autocomplete
                    v-model="item.emisorId"
                    :items="emisoresDisponiblesParaItem(item)"
                    item-title="emisorNombre"
                    item-value="emisorId"
                    :disabled="item.emisoresCoincidentes.length === 0"
                    variant="underlined"
                    dense
                    hide-details
                    id="v-select-emisor-repetido"
                    :menu-props="{ closeOnContentClick: true }"
                    label="Seleccionar emisor"
                  >
                    <template v-slot:item="{ item, props }">
                      <v-list-item v-bind="props">
                        <v-list-item-subtitle v-if="item.raw.emisorId != null">
                          Razon social:
                          {{ item.raw.emisorRazonSocial }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle v-if="item.raw.emisorId != null">
                          Teléfono:
                          {{
                            item.raw.emisoresXfinanciadores[0]?.emisorTelefono
                          }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="item.raw.emisorId != null">
                          Observación:
                          {{
                            item.raw.emisoresXfinanciadores[0]
                              ?.emisorObservacion
                          }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="pb-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              variant="flat"
              :disabled="!enableProcess || !file"
              :loading="loadingBtn"
              @click="saveRegistrosRepetidos"
              id="v-btn-importar-emisores-repetidos"
            >
              Importar
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="openModalFormatoImportacion"
      v-model="openModalFormatoImportacion"
      :max-width="isMobile ? '95%' : '65%'"
      persistent
    >
      <VerFormatoImportaciones
        tipoEntidad="Entidad emisora"
        @closeDialog="closeFormatoModal"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import helpersExcel from "@/utils/helpers/importExportExcel.js";
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums";
import VerFormatoImportaciones from "@/components/shared/VerFormatoImportaciones.vue";

export default {
  name: "ImportarEntidadesEmisoras",
  components: {
    VerFormatoImportaciones,
  },
  props: {
    financiadorId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
    emisoresSeleccionados() {
      return this.emisoresRepetidos
        .map((e) => e.emisorId)
        .filter((id) => id != null);
    },
  },
  data() {
    return {
      loading: false,
      file: null,
      excelData: [],
      fileName: "",
      fileDataTranslated: [],
      dataTableIsLoading: false,
      openModalElegirEmisoresRepetidos: false,
      openModalFormatoImportacion: false,
      emisoresRepetidos: [],
      emisoresRepetidosHeaders: [
        { title: "Nombre", value: "nombre" },
        { title: "CUIT", value: "cuit" },
        { title: "Teléfono", value: "telefono" },
        { title: "Email", value: "email" },
        { title: "Observación", value: "observacion" },
        { title: "Emisor existente", value: "selectEmisor" },
      ],
      loadingBtn: false,
      enableProcess: false,
      expectedHeaders: [
        "Nombre",
        "Razon social",
        "CUIT",
        "Telefono",
        "Email",
        "Observacion",
        "Deshabilitado",
      ],
      errores: [],
      closeIcon: enums.icons.CLOSE_ICON,
    };
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      saveImportacionEntidadesEmisoras:
        "emisor/saveImportacionEntidadesEmisoras",
      saveImportacionEntidadesEmisorasRepetidas:
        "emisor/saveImportacionEntidadesEmisorasRepetidas",
    }),
    clearExcelFile() {
      this.fileDataTranslated = [];
      this.excelData = [];
    },
    async importExcel() {
      try {
        this.loading = true;
        this.excelData = [];
        this.fileDataTranslated = [];
        this.fileName = this.file ? this.file.name : "";

        await this.getArchivo();

        if (!this.hasValidData()) {
          this.setAlert({
            type: "warning",
            message: "Archivo inválido. ",
          });
          return;
        }

        const validHeaders = helpersExcel.validarCabecerasExcel(
          this.file,
          this.expectedHeaders
        );
        if (!validHeaders) {
          this.resetFileInput();
          return;
        }
        this.excelData[0].filas.forEach((x) => {
          this.fileDataTranslated.push({
            nombre: x["NOMBRE"]?.toString()?.trim() ?? "",
            razonSocial: x["RAZON SOCIAL"]?.toString()?.trim() ?? "",
            cuit: x["CUIT"]?.toString().trim() ?? "",
            telefono: x["TELEFONO"]?.toString().trim() ?? "",
            email:
              typeof x["EMAIL"] == "object"
                ? x["EMAIL"].text?.toString().trim()
                : x["EMAIL"]?.toString().trim() ?? "",
            observacion: x["OBSERVACION"]?.toString().trim() ?? "",
            deshabilitado:
              x["DESHABILITADO"]?.toString().trim().toUpperCase() == "SI"
                ? true
                : false ?? "",
          });
        });

        this.enableProcess = true;
      } catch (error) {
        console.error("Error al importar el archivo:", error);
        this.resetFileInput();
      } finally {
        this.loading = false;
      }
    },
    async saveRegistrosRepetidos() {
      this.fileDataTranslated = [];
      const fileDataRepetidos = this.emisoresRepetidos.map((x) => {
        return {
          nombre: x.nombre,
          razonSocial: x.razonSocial,
          cuit: x.cuit,
          cuitUsuario: x.cuitUsuario,
          telefono: x.telefono,
          observacion: x.observacion,
          email: x.email,
          deshabilitado: x.deshabilitado,
          emisorId: x.emisorId, // Asignar el ID del emisor seleccionado
        };
      });
      this.loadingBtn = true;
      const data = {
        financiadorId: this.financiadorId,
        fileData: fileDataRepetidos,
      };
      try {
        const response = await this.saveImportacionEntidadesEmisorasRepetidas(
          data
        );
        if (response.status == 200) {
          this.loadingBtn = false;
          if (response.data) {
            this.setAlert({
              type: "success",
              message: "Entidades emisoras importadas con éxito. ",
            });
          } else {
            this.closeModal();
            this.reloadEmisores();
            this.setAlert({
              type: "warning",
              message: "Ocurrió un error al importar. ",
            });
          }
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al importar entidades emisoras: ${error}`,
        });
        this.resetFileInput();
      }
      this.closeModal();
      this.reloadEmisores();
    },
    emisoresDisponiblesParaItem(item) {
      return item.emisoresCoincidentes.filter(
        (e) =>
          e.emisorId === item.emisorId || // dejar el seleccionado actual
          (!this.emisoresSeleccionados.includes(e.emisorId) && // no elegir dos veces el mismo emisor
            !e.emisoresXfinanciadores?.some(
              (x) => x.financiadorId === this.financiadorId
            )) // no mostrar emisores que ya pertenecen al financiador
      );
    },
    async saveFileData() {
      this.loadingBtn = true;
      const data = {
        financiadorId: this.financiadorId,
        fileData: this.fileDataTranslated,
        nombreArchivo: this.fileName,
      };
      try {
        const response = await this.saveImportacionEntidadesEmisoras(data);
        if (response.status == 200) {
          this.loadingBtn = false;

          // 1. Si hay repetidos, abrir el modal y setear emisoresRepetidos
          if (response.data.validarRepetidos?.length > 0) {
            this.openModalElegirEmisoresRepetidos = true;
            this.emisoresRepetidos = response.data.validarRepetidos.map((x) => {
              x.emisoresCoincidentes.push({
                emisorNombre: "Nuevo emisor",
                emisorId: null,
              });
              return x;
            });
          }

          // 2. Si hay errores, exportarlos y mostrar alerta
          if (response.data.fileData.length > 0) {
            this.errores = response.data.fileData;
            this.setAlert({
              type: "warning",
              message: "Existen datos con errores. ",
            });
            this.exportErrors();
            // Si hubo errores y NO se abrió el modal de repetidos, cerrar modal y recargar emisores
            if (!this.openModalElegirEmisoresRepetidos) {
              this.closeModal();
              this.reloadEmisores();
            }
          }

          // 3. Si NO hay repetidos y NO hay errores, éxito total
          if (
            (!response.data.validarRepetidos ||
              response.data.validarRepetidos.length === 0) &&
            (!response.data.fileData || response.data.fileData.length === 0)
          ) {
            this.setAlert({
              type: "success",
              message: "Datos importados con éxito. ",
            });
            this.closeModal();
            this.reloadEmisores();
          }
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al importar entidades emisoras: ${error}`,
        });
        this.resetFileInput();
      }
    },
    exportErrors() {
      let result = [];
      this.errores.forEach((x) => {
        result.push({
          ["Nombre"]: x.nombre ?? "",
          ["Razon social"]: x.razonSocial ?? "",
          ["CUIT"]: x.cuit ?? "",
          ["Telefono"]: x.telefono ?? "",
          ["Email"]: x.email ?? "",
          ["Observacion"]: x.observacion ?? "",
          ["Deshabilitado"]: x.deshabilitado ? "SI" : "NO",
          ["Errores"]: x.errores,
        });
      });

      let formato = {
        filas: result,
        hoja: "Errores importación",
      };
      helpersExcel.excelExport(
        formato,
        "Errores importación entidades emisoras"
      );
    },
    hasValidData() {
      return (
        this.excelData == undefined || !!this.excelData?.[0]?.filas?.length
      );
    },
    async getArchivo() {
      this.$refs["file"].validate(true);

      if (this.$refs.file.validate())
        this.excelData = await helpersExcel.excelImport(this.file, 0);
      else throw new Error("Archivo inválido");
    },
    resetFileInput() {
      this.$refs["file"].reset();
      this.file = null;
      this.fileName = "";
      this.fileDataTranslated = this.excelData = [];
      this.enableProcess = this.loading = false;
      return;
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    reloadEmisores() {
      this.$emit("reloadEmisores");
    },
    cerrarModalRepetidos() {
      this.openModalElegirEmisoresRepetidos = false;
      this.emisoresRepetidos = [];
      this.closeModal();
      this.reloadEmisores();
    },
    openFormatoModal() {
      this.openModalFormatoImportacion = true;
    },
    closeFormatoModal() {
      this.openModalFormatoImportacion = false;
    },
  },
};
</script>